export const apiMapper = {
  timesheet: {
    list: "/resource/timesheet/",
    managerTimesheet: "/timesheet-manager-notification-count/",
    overview: "/resource/timesheets/",
    timesheetMainPage: "/employee-timesheets/",
    timesheetApprovals: "/timesheet-approval-pending/",
    timesheetApprovalsHrManager: "/timesheet-approval-pending-hr-manager/",
    managerNotificationCount: "/ts-manager-notification-count/",
    timesheetOngoingAllocatedHrs: "/employee-weekly-status/",
    addTimesheet: "/add-employee-timesheet/",
    empTimesheetWeekwiseStatusList: "employee-timesheet-status/",
    empTimesheetTotalUnplannedHrsList: "employee-unplanned-hours/",
    empTimesheetTotalTimeoffHrsList: "employee-timeoff-hours/",
    timesheetApproverSearch: "/timesheet-approver-search/",
    recallTimesheet: "/recall-employee-timesheets/",
    exportTimesheet: "export-employee-timesheets/",
    updateTimesheetByManager: "/update-timesheets-by-manager/",
    updateTimesheetByHrManager: "/update-timesheets-by-hr-manager/",
    missingTimesheets: "/employee-missing-timesheets/",
    timesheetApprovalsAdmin: "/timesheet-admin-list-view/",
    updateTimesheetByAdmin: "/timesheet-admin-bulk-approval/",
    employeeDailyTimesheetReport: "/employee-daily-timesheet-report/",
    missingTimesheetsReport: "/timesheets/missing-submissions/",
    ripplingDailyTimesheetReport: "/employee-rippling-daily-timesheet-report/",
    triggerTimesheetNotification: "/trigger-timesheet-notification/",
    timesheetSubmissionHistory: "/timesheet-submission-history"
  },
  payRate: {
    payRateList: "/skillpayrate",
    getPayRate: "/skillpayrate/",
    createPayRate: "/skillpayrate/",
    updatePayRate: "/skillpayrate/",
    deletePayRate: "/skillpayrate/"
  },
  invoiceAPI: {
    list: "/invoices/client/",
    regenerate: "/regenerate-invoice/",
    paid: "/update_invoices/",
    generateByAmount: "/update_invoices/",
    sendMail: "/send_invoices/",
    saveTemplate: "/invoice-template/",
    fetchInvoices: "/invoices_enhanced/",
    invoiceTemplateList: "/invoice-template/",
    deleteTemplate: "/invoice-template/",
    generateInvoicePdf: "invoice/generate-from-template/",
    generateInvoice: "/generate-invoice"
  },
  users: {
    register: "/user/register",
    forgotPassword: "/user/request-password-reset",
    passwordReset: "/user/password-reset",
    logout: "/user/logout",
    getUserDetails: "/me",
    updateUserDetails: "/me",
    changePassword: "/user/change-password",
    settings: "/user/preferences",
    usersList: "/user",
    getUser: "/user/",
    createUser: "/user",
    updateUser: "/user/",
    deleteUser: "/user/"
  },
  register: {
    login: "/register/",
    forgotPassword: "/user/request-password-reset",
    passwordReset: "/user/password-reset",
    logout: "/user/logout",
    getUserDetails: "/me",
    updateUserDetails: "/me",
    changePassword: "/user/change-password",
    settings: "/user/preferences"
  },
  uploadFile: {
    upload: "/contract/file/upload/",
    delete: "/contract/file-delete/",
    download: "/contract/file-download/",
    extractFileData: "/extract-information/"
  },
  allocation: {
    list: "/allocation/",
    details: "/allocation/enhanced/",
    update: "/allocation/details/",
    delete: "/allocation/details/",
    getEstCon: "/allocation/contractsow/client/",
    getRes: "/allocation/contractsow/",
    add: "/allocation",
    allocationCheck: "/check-allocation/",
    resourceSearch: "/resource/search/",
    enhancedAdd: "/allocation/enhanced/",
    enhancedUpdate: "/allocation/enhanced/",
    employeeDistribution: "/employee/distribution/",
    allocationAnalysis: "/placement-analysis/ ",
    getPlannedHours: "/role-estimation/",
    deleteSubmittedTimesheets: "/delete-employee-timesheets/",
    getSplitHours: "/placement-split-check",
    deletePlacement: "/placements/delete",
    deleteSubmittedTimesheets: "/timesheet-entries/delete"
  },
  client: {
    list: "/client",
    add: "/client",
    update: "/client/",
    addNdaContract: "/contract",
    updateNdaContract: "/contract/details/",
    detail: "/client/",
    delete: "/client/",
    checkClientContractName: "/auto-name-search/"
  },
  contracts: {
    list: "/contractsow/",
    add: "/contractsow/",
    update: "/contractsow/details/",
    detail: "/contractsow/details/",
    delete: "/contractsow/details/",
    check: "/contractsow-check/",
    milestoneNameCheck: "/milestone-name-check/"
  },
  customer: {
    list: "/guest-user/",
    add: "/guest-user/",
    update: "/guest-user/",
    detail: "/guest-user/",
    delete: "/guest-user/",
    getClient: "/guest-user-clients/"
  },
  employee: {
    list: "/employees/",
    add: "/employee/",
    update: "/employee/",
    detail: "/employee/",
    delete: "/employee/",
    activityLogs: "/activity-logs/"
  },
  dashboard: {
    data: "/dashboard/",
    resourceInsights: "/consultants/insights/",
    consultantsList: "consultants/employees/",
    getClientList: "clients/active",
    getContractsCount: "/contractsow/active/count",
    getActiveContracts: "/contractsow/active"
  },
  estimation: {
    list: "/estimation/",
    add: "/estimation",
    update: "/estimation/details/",
    details: "/estimation/details/",
    delete: "/estimation/details/",
    getEstPayRate: "/ratecards/"
  },
  rateCard: {
    getAllRateCards: "/ratecards/",
    addRateCard: "/ratecards/",
    getRateCards: "/ratecards/",
    updateRateCard: "/ratecards/",
    deleteRateCard: "/ratecards/",
    rateCardOptions: "ratecards/filter-options/",
    chatbot:
      "http://rateca-ratec-z0lih99iikku-1344733927.ap-south-1.elb.amazonaws.com/test%22"
  },
  milestone: {
    list: "/milestones/",
    details: "/milestones/details/",
    add: "/milestones/",
    update: "/milestones/details/",
    delete: "/milestones/details/",
    check: "/milestone-check/"
  },
  pricing: {
    add: "/pricing",
    update: "/pricing/details/",
    list: "/pricing/",
    detail: "/pricing/details/",
    delete: "/pricing/details/"
  },
  purchaseOrder: {
    list: "/purchase_orders_client_all/",
    details: "/purchase_orders_by_id/",
    add: "/purchase-orders/",
    update: "/purchase-orders/details/",
    delete: "/purchase-orders/details/",
    deleteFile: "/purchase-orders/",
    uploadFile: "/purchase-orders/file-upload/",
    getAvailablePO: "/purchase_orders_client_unassigned/",
    getAvailableContract: "/unassigned-sow-contracts/",
    addAssignPO: "/purchase_orders_assign/",
    checkPONumberExists: "/purchase-order-check/",
    deleteUtilizedAmount: "/delete-utilized-amounts/"
  },
  reports: {
    resourceCounts: "/projects/resource-counts/",
    financialData: "/finance/financial-data/",
    burndown: "/contracts/burndown/",
    placementReport: "/contracts-ending-report/"
  },
  roles: {
    list: "/roles",
    get: "/roles/",
    create: "/roles",
    update: "/roles/",
    delete: "/roles/",
    permissions: "/permissions"
  },
  resources: {
    utilozationReport: "/employees/utilization-by-range/",
    resourceList: "/role-skill-mapping",
    employeeDailyUtilization: "/fetch-employee-daily-utilization/",
    dailyAllocatedHours: "/fetch-employee-daily-utilization/"
  },
  resourceMetrics: {
    employeeRoleList: "/resource-role-counts/",
    employeeSkillCount: "/resource-skill-counts/",
    employeeCountryTypeList: "/resource-emptype-country-counts/",
    getEmployeEmail: "/auto-search/"
  },
  config: {
    getJsonConfig: "/fetch-blob-json/"
  },
  assetManagement: {
    addHardware: "/add-hardware-asset",

    deleteHardware: "hardware-type-asset-list/",
    hardwareDetails: "hardware-asset-details/",
    addSoftware: "/add-software-asset",
    updateHardware: "update-hardware-asset/",
    softwareList: "/software-type-asset-list",
    hardwareList: "/hardware-type-asset-list",
    deleteSoftware: "software-type-asset-list/",
    updateSoftware: "update-software-asset/",
    softwareDetails: "software-asset-details/",
    // Fetch asset logs
    assetLogs: "/get-asset-logs",
    // Fetch hardware assignment history by asset_id
    hardwareAssignmentHistory: "/get-hardware-assignment-history",
    // Fetch software assignment history by asset_id
    softwareAssignmentHistory: "/get-software-assignment-history",
    // Fetch employee assignment history
    employeeHardwareAssignmentHistory: "/get-employee-hardware-assignment-history",
    employeeSoftwareAssignmentHistory: "/get-employee-software-assignment-history"
  }
};